import { JSX } from "react";

import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  CircularProgress,
  IconButton,
  Modal,
  Paper,
  SxProps,
  Typography,
} from "@mui/material";

interface IBaseModal {
  children: React.ReactNode;
  isOpen: boolean;
  onClose: () => void;
  hideClose?: boolean;
  title?: string;
  customSx?: SxProps;
  customBodySx?: SxProps;
  isLoading?: boolean;
}
export const BaseModal = ({
  children,
  isOpen,
  onClose,
  title,
  customSx,
  customBodySx,
  isLoading,
  hideClose,
}: IBaseModal): JSX.Element => {
  return (
    <Modal
      open={isOpen}
      onClose={hideClose != true ? onClose : () => {}}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
      }}
    >
      <Paper
        sx={{
          position: "relative",
          ...customSx,
        }}
      >
        <Box maxHeight="100vh" overflow="auto">
          {isLoading ? (
            <Box
              sx={{
                position: "absolute",
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: "10",
                background: "rgba(0,0,0,.25)",
              }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <></>
          )}
          <Box pt={1} pb={2} px={1}>
            <Box
              pb={1}
              pl={3}
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography variant="h2">{title ? title : ""}</Typography>
              {hideClose != true ? (
                <IconButton
                  aria-label="delete"
                  onClick={onClose}
                  color="primary"
                  size="large"
                  sx={{
                    p: 0,
                    ">svg": {
                      height: "2em",
                      width: "2em",
                    },
                  }}
                >
                  <CloseIcon />
                </IconButton>
              ) : (
                <></>
              )}
            </Box>
            <Box py={1} px={3} sx={customBodySx}>
              {children}
            </Box>
          </Box>
        </Box>
      </Paper>
    </Modal>
  );
};
